import { Props_SnippetContentColumn } from './ContentColumn.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import SnippetLink from '../Shared/Link/Link'

const SnippetContentColumn = (props: Props_SnippetContentColumn) => {
    const { heading, repeatable_entry } = props
    const classHeadingVisibility: string = heading.visibility.value ? 'snippet-content-column__heading--visible' : 'snippet-content-column__heading--hidden'
    const classHeadingColor: string = heading.color?.value ? `snippet-content-column__heading--color-${heading.color.value}` : ''

    return (
        <section className="snippet-content-column">
            <div className={`snippet-content-column__container`}>
                <div className={`snippet-content-column__heading ${classHeadingVisibility} ${classHeadingColor}`}>{CompileMarkdown(heading.content.value!)}</div>
                <div className="snippet-content-column__container-entries">
                    {repeatable_entry.map(({ image, alt, heading, headingColor, content, linkHref, linkStyle, linkText, linkTarget }, index: number) => (
                        <div key={index} className={`snippet-content-column__entry`}>
                            {image?.value && (
                                <figure className="snippet-content-column__entry-image-container">
                                    <img
                                        className="snippet-content-column__entry-image"
                                        loading="lazy"
                                        height={190}
                                        width={350}
                                        src={image.value}
                                        alt={alt?.value ? alt.value : ''}
                                    />
                                </figure>
                            )}
                            <div className="snippet-content-column__entry-content-container">
                                {heading?.value && (
                                    <>
                                        <div className={`snippet-content-column__entry-title ${headingColor?.value ? `snippet-content-column__entry-title--color-${headingColor.value}` : ''}`}>{CompileMarkdown(heading.value)}</div>
                                    </>
                                )}
                                {content?.value && <div className="snippet-content-column__entry-content">{CompileMarkdown(content.value)}</div>}
                                <SnippetLink
                                    linkStyles={linkStyle?.value}
                                    className="snippet-content-column__entry-link"
                                    url={linkHref?.value}
                                    openInNewTab={linkTarget?.value}
                                >
                                    {linkText?.value}
                                </SnippetLink>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default SnippetContentColumn